/* Neuvara — produktsida: paketväljare, galleri, sticky köpfält */
document.addEventListener('DOMContentLoaded', function () {
  var bundles = document.getElementById('bundles');
  if (bundles) {
    var vid      = document.getElementById('variantId');
    var pPrice   = document.getElementById('pPrice');
    var pCompare = document.getElementById('pCompare');
    var pSave    = document.getElementById('pSave');
    var pPerLamp = document.getElementById('pPerLamp');
    var atcPrice = document.getElementById('atcPrice');
    var sbPrice  = document.getElementById('sbPrice');
    var sbLabel  = document.getElementById('sbLabel');

    function pick(card) {
      bundles.querySelectorAll('.bundle').forEach(function (c) { c.classList.remove('on'); });
      card.classList.add('on');
      var r = card.querySelector('input[type=radio]');
      if (r) r.checked = true;

      var price = card.dataset.price,
          per   = card.dataset.perlamp,
          n     = card.dataset.n;

      if (vid)      vid.value = card.dataset.vid;
      if (pPrice)   pPrice.textContent = price;
      if (pPerLamp) pPerLamp.textContent = per;
      if (atcPrice) atcPrice.textContent = price;
      if (sbPrice)  sbPrice.textContent = price;
      if (sbLabel)  sbLabel.textContent = n + ' lampor · ' + per + '/lampa';

      var has = card.dataset.hascompare === '1';
      if (pCompare) { pCompare.textContent = has ? card.dataset.compare : ''; pCompare.hidden = !has; }
      if (pSave)    { pSave.textContent    = has ? 'Spara ' + card.dataset.save : ''; pSave.hidden = !has; }

      // håll URL:en i synk så delade länkar öppnar rätt paket
      try {
        var u = new URL(window.location);
        u.searchParams.set('variant', card.dataset.vid);
        window.history.replaceState({}, '', u);
      } catch (e) {}
    }

    bundles.querySelectorAll('.bundle').forEach(function (card) {
      card.addEventListener('click', function () { pick(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(card); }
      });
    });
  }

  /* galleri: byt huvudbild */
  var heroImg = document.getElementById('heroImg');
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!heroImg) return;
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      heroImg.src = t.dataset.full;
    });
  });

  /* sticky köpfält — upp när huvudknappen scrollat förbi */
  var sticky = document.getElementById('stickyBuy');
  var atc    = document.getElementById('atcBtn');
  if (sticky && atc) {
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sticky.classList.toggle('up', !e.isIntersecting); });
    }, { rootMargin: '-80px 0px 0px 0px' });
    sio.observe(atc);
  }
});
